import React, { useState, useEffect } from 'react';

function TabItem({ href, label }) {
  const [hovered, setHovered] = useState(false);
  // 新增 state 來監控視窗寬度與高度
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 判斷是否為直屏 (portrait)：高度大於寬度
  const isPortrait = windowSize.height > windowSize.width;
  // 直屏時基礎字體設定為 20px，否則為 16px
  const baseFontSize = isPortrait ? 20 : 16;
  // hovered 狀態下字體增加 2px
  const fontSize = hovered ? baseFontSize + 2 : baseFontSize;

  const fillOpacity = hovered ? 1 : 0.8;
  const scale = hovered ? 1.05 : 1.0;

  return (
    <a
      href={href}
      className="mx-1 flex-1"
      style={{
        transform: `scale(${scale})`,
        transition: 'transform 0.3s',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onTouchStart={() => setHovered(true)}
      onTouchEnd={() => setHovered(false)}
    >
      <svg
        viewBox="0 0 200 40"
        preserveAspectRatio="none"
        className="w-full h-auto"
      >
        <defs>
          <clipPath id="tabClip">
            <path d="M0,15 Q0,0 15,0 L185,0 Q200,0 200,15 L200,40 L0,40 Z" />
          </clipPath>
        </defs>

        <rect
          x="0"
          y="0"
          width="200"
          height="40"
          clipPath="url(#tabClip)"
          fill="white"
          fillOpacity={fillOpacity}
          style={{ transition: 'fill-opacity 0.3s' }}
        />

        <text
          x="100"
          y="25" 
          textAnchor="middle"
          fill="black"
          fontWeight="bold"
          style={{
            pointerEvents: 'none',
            fontFamily: '"Apple LiSu", "Pixel LiSu", "Android LiSu", "LiSu", "隸書", serif',
            fontSize: `${fontSize}px`,
            transition: 'font-size 0.3s',
          }}
        >
          {label}
        </text>
      </svg>
    </a>
  );
}

export default function TabBar() {
  return (
    <div className="flex w-full justify-between px-2">
      <TabItem href="#info" label="婚禮資訊" />
      <TabItem href="#album" label="婚紗照" />
      <TabItem href="#form" label="表單" />
    </div>
  );
}
